import {OAuthEvent, OAuthService} from "angular-oauth2-oidc";
import {HttpClient, HttpHeaders, HttpParams, HttpResponse} from "@angular/common/http";
import {HandleError, HttpErrorHandlerService} from "./http-error-handling.service";
import {firstValueFrom, Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {environment} from "../../environments/environment";

interface VersionInfo {
  name: string
  description: string
  version: string
}


export class ApiClientBaseService {
  protected handleError: HandleError;
  protected uriPrefix: string = '';

  protected httpHeaders= new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  });

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              private httpErrorHandler: HttpErrorHandlerService) {

    if (typeof environment.auth == 'string') {
      this.httpHeaders = this.httpHeaders.set('Authorization', `Bearer ${environment.auth}`);
    } else {
      this.oauthService.events.subscribe((event: OAuthEvent) => {
        const tokenUpdatedEvents = ['token_refreshed', 'token_received', 'silently_refreshed'];
        if (tokenUpdatedEvents.includes(event.type)) {
          this.httpHeaders = this.httpHeaders.set('Authorization', this.oauthService.authorizationHeader());
        }
      });

      this.httpHeaders = this.httpHeaders.set('Authorization', this.oauthService.authorizationHeader());
    }

    this.handleError = httpErrorHandler.createHandleError('ApiClientBaseService');
  }

  protected get<T>(url: string, params?: { [index: string]: any }): Observable<T> {
    return this.http.get<T>(`${this.uriPrefix}${url}`, {
      params: this.createHttpParams(params),
      headers: this.httpHeaders,
    });
  }

  protected postFile<T>(url: string, file: any, params?: { [index: string]: any }): Observable<T> {
    const fileHeaders = new HttpHeaders({
      'Authorization': this.httpHeaders.get('Authorization'),
    });

    console.dir(file);

    return this.http.post<T>(`${this.uriPrefix}${url}`, file, {
      params: this.createHttpParams(params),
      headers: fileHeaders,
    });
  }


  protected post<T>(url: string, body: any, params?: { [index: string]: any }): Observable<T> {
    return this.http.post<T>(`${this.uriPrefix}${url}`, body, {
      params: this.createHttpParams(params),
      headers: this.httpHeaders,
    });
  }

  protected postText<T>(url: string, body: string, params?: { [index: string]: any }): Observable<T> {
    return this.http.post<T>(`${this.uriPrefix}${url}`, body, {
      params: this.createHttpParams(params),
      headers: this.httpHeaders.set('Content-Type', 'text/plain'),
    });
  }

  protected async postWithResponse<T>(url: string, body: any, params?: { [index: string]: any }): Promise<HttpResponse<T>> {
    return firstValueFrom(
      this.http.post<T>(`${this.uriPrefix}${url}`, body, {
        params: this.createHttpParams(params),
        headers: this.httpHeaders,
        observe: 'response' // Get full HTTP response (headers + body)
      })
    );
  }

  protected put<T>(url: string, body: any, params?: { [index: string]: any }): Observable<T> {
    return this.http.put<T>(`${this.uriPrefix}${url}`, body, {
      params: this.createHttpParams(params),
      headers: this.httpHeaders,
    });
  }

  protected delete<T>(url: string, params?: { [index: string]: any }): Observable<T> {
    return this.http.delete<T>(`${this.uriPrefix}${url}`, {
      params: this.createHttpParams(params),
      headers: this.httpHeaders,
    });
  }

  public getVersion(): Observable<VersionInfo> {
    return this.get<VersionInfo>('/ver').pipe(catchError(this.handleError('getVersion', null)))
  }

  protected createHttpParams(params: { [index: string]: any }): HttpParams {
    if (params == null) {
      return null;
    }

    let httpParams: HttpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        if (value != null) {
          httpParams = httpParams.set(key, value);
        }
      }
    }
    return httpParams;
  }

}
